export const VARIABLES = ['a', 'b', 'x', 'y']

export const SIGNS = ['+', '-']

export const RANGE_DATA: RangeDataModel = {
  1: {
    minTerms: 4,
    maxTerms: 10,
    minExponent: 1,
    maxExponent: 3,
    minCoefficient: 1,
    maxCoefficient: 5,
    minInteger: 1,
    maxInteger: 10,
  },
  2: {
    minTerms: 4,
    maxTerms: 10,
    minExponent: 3,
    maxExponent: 5,
    minCoefficient: 1,
    maxCoefficient: 5,
    minInteger: 1,
    maxInteger: 10,
  },
}

interface RangeDataModel {
  [key: number]: RangeItemModel
}

interface RangeItemModel {
  minTerms: number
  maxTerms: number
  minExponent: number
  maxExponent: number
  minCoefficient: number
  maxCoefficient: number
  minInteger: number
  maxInteger: number
}
